import { Injectable } from '@angular/core';
import {Http, Response } from '@angular/http'

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';


import { User } from './user';

@Injectable()
export class UserService {

  private usersUrl = '/api/users';

  constructor(private http: Http) { }

  getUsers(): Observable<User[]> {
    return this.http.get(this.usersUrl).map(response => {
      return response.json() as User[]
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/users/user.service.ts